// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F_Jk","content":"styles_content__2jXZH","row":"styles_row__1ayIi","footer":"styles_footer__t_rU1","phraseLength":"styles_phraseLength__2Ye8R"};